import { DisplayMessage } from './display-message';
import { ChatMessage } from '../../../model/chat-message';
import { DisplayItemType } from './display-item';
import { Observable } from 'rxjs';

// eslint-disable-next-line customAfoRule/enforce-afo-doc
export class DisplayMessageFile extends DisplayMessage {
  url?: string;
  tooltip?: string;
  isLoaded?: boolean;
  blob?: Blob;
  isValid?: boolean;

  constructor(
    message: ChatMessage,
    isPinned = false,
    isLastReadByAll$?: Observable<boolean>,
    inReplyTo?: DisplayMessage
  ) {
    super(message, isPinned, isLastReadByAll$, inReplyTo);
  }

  override get type(): DisplayItemType {
    return DisplayItemType.FILEMESSAGE;
  }

  get name(): string {
    const content = this.message.first.getContent();
    return (content?.['filename'] || content?.['body']) ?? 'file';
  }

  get size(): number {
    const contentInfo = this.message.first.getContent()?.['info'];
    return contentInfo?.size || 0;
  }

  get mimetype(): string {
    const contentInfo = this.message.first.getContent()?.['info'];
    return contentInfo?.mimetype || '';
  }
}
